import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Namespace } from '../../../../translation/namespace';
import FormHelp from '../../../../components/molecules/Form/components/FormHelp/FormHelp';
import { ConfidentialLevel } from '../../../../types/api/ConfidentialLevel';
import { MetaInfoDescription } from './MetaInfoDescription';
import { useAppContext } from '../../../../contexts/AppContext/AppContext';

export function ConfidentialLevelMetaInfo({ confidentialLevel }: { confidentialLevel: ConfidentialLevel }) {
  const { t } = useSonTranslation('MetaInfo');
  const { pageInfo } = useAppContext();

  return (
    <MetaInfoDescription term={t(`${Namespace.glossary}:classification`)}>
      <p className="meta-info__security-clearance">
        {t(`${Namespace.phrases}:securityClearance.${confidentialLevel}.text`)}
        <FormHelp
          id="formhelp-confidential-level"
          helpText={t(`${Namespace.phrases}:helptextsecurityClearance.${confidentialLevel}`)}
          modifier={pageInfo?.printable ? 'noprint' : undefined}
        />
      </p>
    </MetaInfoDescription>
  );
}
